import { Link } from "react-router-dom";
import SortIcon from "../../../global/components/SortIcon";
import { DeleteOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const LicenseCodeColumns = (
  hoveredRow,
  setShowModal,
  setSelectedRowKeys,
  setParams,
  params,
  modifiedItems,
  modifiedTypes,
) => {
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {}; //

  return [
    {
      title: "Item",
      dataIndex: "Item",
      key: "Item",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Item"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Item",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
      render: (_, item) => {
        const matchedItem = modifiedItems?.find(
          (modItem) => modItem.value === item?.Item,
        );
        return matchedItem?.label || "";
      },
    },

    {
      title: "Code",
      dataIndex: "Code",
      key: "Code",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Code"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Code",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Name",
      dataIndex: "CodeName",
      key: "CodeName",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="CodeName"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "CodeName",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Price Type",
      dataIndex: "Monthly",
      key: "Monthly",
      render: (_, record) => {
        const perUnitItems = new Set([3, 202, 203, 204, 205, 206, 207, 208]);
        const perHundredUnitItems = new Set([209]);
        const itemType = record.Item;
        const label = perUnitItems.has(itemType)
          ? "1 Unit"
          : perHundredUnitItems.has(itemType)
            ? "100 Units"
            : "Total";

        return label;
      },
    },
    {
      title: "Monthly",
      dataIndex: "Monthly",
      key: "Monthly",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Monthly"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Monthly",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
      render: (item) => {
        return typeof item === "string" ? "$ " + item : item;
      },
    },
    {
      title: "Lifetime",
      dataIndex: "Lifetime",
      key: "Lifetime",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Lifetime"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Lifetime",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
      render: (item) => {
        return typeof item === "string" ? "$ " + item : item;
      },
    },
    // {
    //   title: "Surcharge",
    //   dataIndex: "Surcharge",
    //   key: "Surcharge",
    //   sorter: (a, b) => () => {},
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={modParams.order}
    //       columnKey="Surcharge"
    //       sortBy={modParams.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...modParams,
    //         sort_by: "Surcharge",
    //         order: modParams.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    //   render: (text) => {
    //     const matchedValue = discountOptions.find(
    //       (item) => item.value === text
    //     )?.label;
    //     return <>{matchedValue}</>;
    //   },
    // },
    {
      title: "",
      fixed: "right",
      width: 0,
      align: "center",
      render: (text, record, rowIndex) =>
        hoveredRow === rowIndex ? (
          <div className="absolute top-2 right-5">
            <div className="bg-[#EFF0F2] duration-75 bottom-0 flex gap-2 items-center justify-center z-50">
              <Tooltip title="Edit">
                <Link
                  to={`/licensecode/edit/${record.CodeNo}`}
                  onClick={(e) => e.stopPropagation()}
                  className=" hover:text-[#636262ee]"
                >
                  <div className="hover:bg-gray-400 px-[5px] py-1 rounded-[4px] mr-1 ">
                    <FontAwesomeIcon
                      icon={faEdit}
                      className="!text-[#50565e]"
                    />
                  </div>
                </Link>
              </Tooltip>
              <Tooltip title="Delete">
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowModal(true);
                    setSelectedRowKeys([record?.CodeNo]);
                  }}
                  className="cursor-pointer hover:bg-gray-400 px-[5px] py-1 rounded-[4px] "
                >
                  <DeleteOutlined />
                </div>
              </Tooltip>
            </div>
          </div>
        ) : null,
    },
  ];
};
